import $ from 'jquery';

import isTouch from '../util/touch';

import initSectionModels from './model';
import productNativeVideo from './native-video-player';
import embedYoutube from './youtube-player';

var selectors = {
  productSlideshow: '[data-product-slideshow]',
  productThumbs: '[data-product-thumbs]',
  thumbImage: '[data-slideshow-thumbnail]',
  productImage: '[data-product-image]',
  mediaSlide: '[data-media-slide]',
  dataMediaId: 'data-media-id',
  mediaType: 'data-type',
  videoPlayerExternal: '[data-type="external_video"]',
  videoPlayerNative: '[data-type="video"]',
  modelViewer: '[data-type="model"]',
  allPlayers: '[data-player]',
  xrButton: '[data-shopify-xr]',
  xrButtonId: 'data-shopify-model3d-id',
  loopVideo: 'data-enable-video-looping',
  flickitylockHeight: 'flickity-lock-height',
  alignment: 'data-thumbs-align',
};

class Media {
  constructor(section) {
    this.section = section;
    this.container = section.container;
    this.slideshow = this.container.querySelector(selectors.productSlideshow);
    this.thumbWrapper = this.container.querySelector(selectors.productThumbs);
    this.thumbImages = this.container.querySelectorAll(selectors.thumbImage);
    this.loopVideo = this.container.getAttribute(selectors.loopVideo) === 'true';
    this.centerAlign = this.container.getAttribute(selectors.alignment) === 'center';

    this.flkty = null;
    this.flktyThumbs = null;
    this.currentSlide = null;

    this.init();
  }

  init() {
    this.createSlider();
    this.detectVideo();
    this.detectYouTube();
    this.detect3d();
  }

  createSlider() {
    if (!this.slideshow) {
      return;
    }

    const instance = this;


    $(this.slideshow, this.$container)
      .on('init', function(){
        $('.media__thumb', this.$container).first().addClass('is-selected');
      })
      .on('beforeChange', function(evt, slick, currentSlide, nextSlide) {
      })
      .on('afterChange', function(evt, slick, currentSlide) {
        let mediaId = slick.$slides.filter(`[data-slick-index="${currentSlide}"]`).find('[data-media-slide]').attr('data-media-id');
        $('.media__thumb', this.$container).removeClass('is-selected');
        $('.media__thumb', this.$container).filter(`[data-media-select="${mediaId}"]`).addClass('is-selected');
      })
      .slick({
        "arrows": true,
        "fade": true,
        "dots": false
      });

    this.eventListeners();
  }

  eventListeners() {
    this.slideshow.addEventListener(
      'theme:image:change',
      function (event) {
        var mediaId = event.detail.id,
            $mediaImage = $(`[${selectors.dataMediaId}="${mediaId}"]`);
        if( !$mediaImage.length ) {
          return;
        }
        let $slideSlide = $mediaImage.closest('.slick-slide'),
            slickIndex = parseInt( $mediaImage.closest('.slick-slide').attr('data-slick-index') ) || 0;
        $(this.slideshow, this.$container).slick('goTo', slickIndex);
      }.bind(this)
    );

    this.thumbImages.forEach((thumb) => {
      thumb.addEventListener(
        'click',
        function (event) {
          const id = event.currentTarget.getAttribute('data-media-select');
          this.slideshow.dispatchEvent(
            new CustomEvent('theme:image:change', {
              detail: {
                id: id,
              },
            })
          );
        }.bind(this)
      );
    });
  }

  sliderThumbs() {
    // let opts = {
    //   freeScroll: true,
    //   contain: true,
    //   prevNextButtons: false,
    //   pageDots: false,
    //   accessibility: true,
    //   cellAlign: this.centerAlign ? 'center' : 'left',
    //   sync: this.slideshow,
    // };
    // this.flktyThumbs = new FlickitySync(this.thumbWrapper, opts);
  }

  confirmSync() {
    // if (this.flkty.selectedIndex !== this.flktyThumbs.selectedIndex) {
    //   this.flkty.resize();
    // }
  }

  setDraggable() {
    // if (this.currentSlide) {
    //   const mediaType = this.currentSlide.getAttribute(selectors.mediaType);

    //   if (mediaType === 'model' || mediaType === 'video' || mediaType === 'external_video') {
    //     // fisrt boolean sets value, second option false to prevent refresh
    //     this.flkty.options.draggable = false;
    //     this.flkty.updateDraggable();
    //   } else {
    //     this.flkty.options.draggable = true;
    //     this.flkty.updateDraggable();
    //   }
    // }
  }

  detect3d() {
    const modelViewerElements = this.container.querySelectorAll(selectors.modelViewer);
    if (modelViewerElements) {
      modelViewerElements.forEach((element) => {
        initSectionModels(element, this.section.id);
      });
      document.addEventListener(
        'shopify_xr_launch',
        function () {
          this.container.querySelectorAll(selectors.allPlayers).forEach((player) => {
            player.dispatchEvent(new CustomEvent('pause'));
          });
        }.bind(this)
      );
    }
  }

  detectVideo() {
    const playerElements = this.section.container.querySelectorAll(selectors.videoPlayerNative);
    for (var player of playerElements) {
      const uniqueKey = player.dataset.player;
      const nativePlayerPromise = productNativeVideo(uniqueKey);
      if (this.loopVideo === true) {
        nativePlayerPromise
          .then((nativePlayer) => {
            nativePlayer.loop = true;
            return nativePlayer;
          })
          .catch((err) => {
            console.error(err);
          });
      }
    }
  }

  detectYouTube() {
    const playerElements = this.section.container.querySelectorAll(selectors.videoPlayerExternal);
    for (var player of playerElements) {
      const uniqueKey = player.dataset.player;
      const youtubePlayerPromise = embedYoutube(uniqueKey);
      if (this.loopVideo === true) {
        youtubePlayerPromise
          .then((youtubePlayer) => {
            return _setToLoop(youtubePlayer);
          })
          .catch((err) => {
            console.error(err);
          });
      }
    }
  }

  pauseAllMedia() {
    const all = this.container.querySelector(`[data-media-slide]`);
    all.dispatchEvent(new CustomEvent('pause'));
  }

  pauseOtherMedia(uniqueKey) {
    const otherMedia = this.container.querySelector(`[data-media-slide]:not([data-player="${uniqueKey}"])`);
    otherMedia.dispatchEvent(new CustomEvent('pause'));
  }

  destroy() {
    this.container.querySelectorAll(selectors.allPlayers).forEach((player) => {
      player.dispatchEvent(new CustomEvent('destroy'));
    });
  }
}

function _setToLoop(youtubePlayer) {
  youtubePlayer.addEventListener('onStateChange', function (event) {
    if (event.data === 0) {
      // video is over, replay
      event.target.playVideo();
    }
  });
  return youtubePlayer;
}

export default Media;
